const getTimezone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (!timezone) {
    return "America/La_Paz";
  }

  return timezone;
};

export default getTimezone;
